<template>
    <vx-card title="My TODO List">

    <vs-list>
      <vs-list-item v-for="item in toggles" :key="item.id" :title="item.address" :subtitle="`Requested on ${item.created_at}`">
        <template slot="avatar">
          <vs-avatar size="large" src="https://placehold.it/50x50" />
        </template>
        
        <router-link :to="`toggle-results/${item.id}`">View</router-link>
      </vs-list-item>
    </vs-list>

    </vx-card>
</template> 

<script>
import axios from 'axios'
import authHeader from '@/services/auth-header'

export default {
  name: 'MyToggles',
  data () {
    return {
      toggles: null
    }
  },
  computed: {
    active_user () { 
      return this.$store.state.active_user
    }
  },
  mounted () {
    this.get_toggles()
  },
  methods: {
    get_toggles () {
      axios.get(`${process.env.VUE_APP_API_HOST}todo/my`, authHeader()).then(response => {
        if (response.data.toggles) {
          this.toggles = response.data.toggles
        }
      })
        .catch(error => {
          this.$vs.notify({
            'time':10000,
            'title':'Error',
            'text':error.message,
            'color':'danger'
          })
          return false
        })
    }
  }
}
</script>
